import * as React from 'react'
import { useLoaderData } from 'react-router-dom'
import { Box, Typography, Grid, Button } from '@mui/material'
import { round } from '../../misc/other'
import { appendLeadingZeros, mysqlDateTransform, addMonthsToDate, todaysDate } from '../../misc/dates'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { ProccRecurPaymentAlert } from '../../alerts/ProcessRecurringPayment'


export const RecurringPaymentProcess = () =>{

    let loaderdata = useLoaderData()
    let initialData = {customer_number: 4001,
                        street_address_1: '1 Address',
                        street_address_2: '2 Address',
                        city: 'Pocahontas',
                        state: 'ST',
                        zip: '77777',
                        zip4: '7777',
                        settlement_amount: 10000.45,
                        original_creditor: 'Chucky Cheese',
                        batch_number: '999997777',
                        email: 'test@gmail.com'


    }
    
    const [accountSelected, setAccountSelected] = React.useState([initialData])
    const [disableButtons, setDisableButtons] = React.useState(true)
    const [processAlert, setProcessAlert] = React.useState(false)
    const [amount, setAmount] = React.useState(0)
    const [date, setDate] = React.useState(todaysDate)

    


    
    const closeProcessAlert = () =>{
        setProcessAlert(false)
    }

    const columns =[
           {field: 'id', headerName: 'ID', flex: 1},
           {field: 'customer_number', headerName: 'customer_number', flex: 2},
           {field: 'full_name', headerName: 'Name', flex: 3},
           {field: 'email', headerName: 'Email', flex: 3},
           {field: 'number_of_payments', headerName: 'Left', flex: 2},
           {field: 'last_transaction', headerName: 'Date', flex: 2}
    

    ]

const rowClick = (row) =>{
    let i = 0
    const newArray = Array.from(row.ids)
    if(!newArray.length || newArray.length!==1){setDisableButtons(true)}

    else{
        
        setDisableButtons(false)
        let rowSelected = []
        while (i<(loaderdata.length)){
            if(newArray.includes(loaderdata[i].id)){
                rowSelected.push(loaderdata[i])
                setAccountSelected(rowSelected)
                
                setAmount(round(rowSelected[0].account_balance/rowSelected[0].number_of_payments))
                
                const newDate = addMonthsToDate(rowSelected[0].last_transaction, 1)
                
                const mysqlDate = mysqlDateTransform(newDate, appendLeadingZeros)
                
                setDate(mysqlDate)
            }
            i++
        }

        
    }
    
}

const onProcessClick = () =>{
    
    setProcessAlert(true)
}

return(
    <Box sx={{minHeight:'80vh', mt: 15, mb: 2}}>
        <ProccRecurPaymentAlert open={processAlert} accounts={accountSelected} amount={amount} setAmount={setAmount} onClose={closeProcessAlert} date={date} setDate={setDate} />
        <Grid container direction='column' sx={{justifyContent:'center', alignItems:'center'}}>
            <Typography color='primary' variant='h5' sx={{mb: 2}}> Select and Account to Process:</Typography>
            <Grid size={{xs: 10}}>
            <DataGridPro 
                columns={columns}
                rows={loaderdata}
                autoPageSize={true}
                checkboxSelection
                disableMultipleRowSelection={true}
                columnBufferPx={150}
                hideFooter={false}
                onRowSelectionModelChange={rowClick}
            />    
            
            

            </Grid>
        </Grid>
        <Grid container direction='row' sx={{mt: 1, alignItems: 'baseline', justifyContent: 'flex-end'}}>
            <Grid sx={{mr: 20}}>
            <Button size='large' variant='contained' disabled={disableButtons} > History </Button>
            <Button size='large' sx={{ml: 1}} variant='contained' disabled={disableButtons} onClick={onProcessClick} > Process </Button>
        </Grid>
        </Grid>
    </Box>
        )

}